export default {
  props: ["headers", "items", "noDataText", "global"],
  data: () => ({
    page: 1,
    itemsPerPage: 10,
    filter: {
      s: ""
    }
  }),
  methods: {
    async nextPage() {
      const pages = Math.ceil(this.items.length / this.itemsPerPage);
      if (this.page < pages) {
        this.page++;
      }
    },
    async previousPage() {
      if (this.page > 1) {
        this.page--;
      }
    }
  }
};
